import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  loadingHandler,
  fulfilledHandler,
  rejectedHandler,
  fulfilledHandlerIdle,
} from "./initialState";
import api from "../api";

export const VerificationOTP = createAsyncThunk(
  "user/VerificationOTP",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}auth/verification/${data.dataOTP}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      data.cb(response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const ChangeEmailOTP = createAsyncThunk(
  "user/ChangeEmailOTP",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}auth/verification/change_email`,
        {
          email: data.email,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      data.cb(response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const ResendOTP = createAsyncThunk(
  "user/ResendOTP",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(`${api}auth/resend_verification`, {
        headers: {
          Authorization: token,
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const PasswordRecovery = createAsyncThunk(
  "user/ForgetPassword",
  async (email, thunkAPI) => {
    try {
      const response = await axios.post(`${api}user/forgot_password/`, {
        email,
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const OTPSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(VerificationOTP.pending, loadingHandler);
    builder.addCase(VerificationOTP.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(VerificationOTP.rejected, rejectedHandler);
    // resend otp
    builder.addCase(ChangeEmailOTP.pending, loadingHandler);
    builder.addCase(ChangeEmailOTP.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(ChangeEmailOTP.rejected, rejectedHandler);
    // resend otp
    builder.addCase(ResendOTP.pending, loadingHandler);
    builder.addCase(ResendOTP.fulfilled, fulfilledHandlerIdle);
    builder.addCase(ResendOTP.rejected, rejectedHandler);
    // forget password
    builder.addCase(PasswordRecovery.pending, loadingHandler);
    builder.addCase(PasswordRecovery.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(PasswordRecovery.rejected, rejectedHandler);
  },
});

export const { reset } = OTPSlice.actions;
export default OTPSlice.reducer;
